<div *ngIf="isLoading" class="row text-center mb-2">
  <i class="fa fa-spinner fa-spin fa-3x" aria-hidden="true"></i>
</div>
